import React, { useState } from "react";
import {
  UserCheck,
  Clock,
  CheckCircle,
  XCircle,
  Eye,
  Download,
  Filter,
  Search,
  AlertCircle,
  FileText,
  Award,
  Briefcase,
  GraduationCap,
  Mail,
  Phone,
  MapPin,
  Calendar,
  Star,
  TrendingUp,
  Users,
  ThumbsUp,
  ThumbsDown,
  MessageSquare,
  ExternalLink,
} from "lucide-react";
import "../../../assets/css/admin/MentorsVerification.css";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

const MentorsVerification = () => {
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [viewDocumentModal, setViewDocumentModal] = useState(null);
  const [viewMode, setViewMode] = useState("table");

  const applications = [
    {
      id: 1,
      applicantName: "Dr. Kamran Siddiqui",
      email: "kamran.siddiqui@email.com",
      phone: "+92 300 1234567",
      location: "Karachi, Pakistan",
      appliedDate: "2025-01-08",
      status: "Pending",
      expertise: "Cloud Computing & DevOps",
      experience: "8 years",
      education: "PhD in Computer Science",
      currentRole: "Senior Cloud Architect at TechCorp",
      linkedIn: "linkedin.com/in/kamransiddiqui",
      portfolio: "kamransiddiqui.dev",
      expectedStudents: 30,
      availability: "Weekends",
      hourlyRate: "$50",
      documents: [
        { type: "Resume/CV", name: "Kamran_CV.pdf", size: "2.3 MB" },
        {
          type: "Degree Certificate",
          name: "PhD_Certificate.pdf",
          size: "1.8 MB",
        },
        {
          type: "Experience Letter",
          name: "TechCorp_Letter.pdf",
          size: "890 KB",
        },
        { type: "ID Proof", name: "CNIC_Front.jpg", size: "1.2 MB" },
      ],
      bio: "Experienced cloud architect with 8+ years of expertise in AWS, Azure, and GCP. Passionate about teaching DevOps practices and cloud-native development. Successfully mentored 50+ professionals in their cloud journey.",
      skills: [
        "AWS",
        "Docker",
        "Kubernetes",
        "Terraform",
        "CI/CD",
        "Python",
        "Go",
      ],
      certifications: [
        "AWS Solutions Architect Professional",
        "Google Cloud Professional",
        "CKA",
      ],
      previousMentoring: "Mentored 50+ students at CloudAcademy",
      rating: null,
    },
    {
      id: 2,
      applicantName: "Ayesha Rahman",
      email: "ayesha.rahman@email.com",
      phone: "+92 321 9876543",
      location: "Lahore, Pakistan",
      appliedDate: "2025-01-09",
      status: "Pending",
      expertise: "UI/UX Design & Product Design",
      experience: "6 years",
      education: "Master's in HCI",
      currentRole: "Lead Product Designer at DesignHub",
      linkedIn: "linkedin.com/in/ayesharahman",
      portfolio: "ayeshadesigns.com",
      expectedStudents: 25,
      availability: "Evenings",
      hourlyRate: "$45",
      documents: [
        { type: "Resume/CV", name: "Ayesha_Resume.pdf", size: "1.9 MB" },
        { type: "Degree Certificate", name: "Masters_HCI.pdf", size: "1.5 MB" },
        { type: "Portfolio", name: "Design_Portfolio.pdf", size: "5.2 MB" },
        { type: "ID Proof", name: "CNIC.pdf", size: "980 KB" },
      ],
      bio: "Award-winning product designer specializing in user-centered design. Led design teams at Fortune 500 companies. Passionate about mentoring aspiring designers and sharing industry best practices.",
      skills: [
        "Figma",
        "Adobe XD",
        "Design Systems",
        "User Research",
        "Prototyping",
        "UI Design",
      ],
      certifications: [
        "Google UX Design Professional",
        "Nielsen Norman Group UX Certification",
      ],
      previousMentoring: "Mentored 30+ designers at Design Bootcamp",
      rating: null,
    },
    {
      id: 3,
      applicantName: "Hassan Malik",
      email: "hassan.malik@email.com",
      phone: "+92 333 5551234",
      location: "Islamabad, Pakistan",
      appliedDate: "2025-01-05",
      status: "Approved",
      expertise: "Full Stack Development",
      experience: "10 years",
      education: "BS Computer Science",
      currentRole: "Tech Lead at StartupX",
      linkedIn: "linkedin.com/in/hassanmalik",
      portfolio: "hassanmalik.io",
      expectedStudents: 40,
      availability: "Flexible",
      hourlyRate: "$60",
      documents: [
        { type: "Resume/CV", name: "Hassan_CV.pdf", size: "2.1 MB" },
        { type: "Degree Certificate", name: "BS_CS.pdf", size: "1.4 MB" },
        {
          type: "Experience Letter",
          name: "StartupX_Letter.pdf",
          size: "750 KB",
        },
      ],
      bio: "Full-stack developer with a decade of experience building scalable web applications. Expertise in React, Node.js, and cloud technologies. Love helping developers level up their skills.",
      skills: [
        "React",
        "Node.js",
        "TypeScript",
        "PostgreSQL",
        "AWS",
        "GraphQL",
        "Docker",
      ],
      certifications: ["AWS Certified Developer", "Google Cloud Professional"],
      previousMentoring: "Active mentor on CodeMentor with 4.9/5 rating",
      rating: 4.9,
      verifiedDate: "2025-01-06",
      verifiedBy: "Admin Sarah",
    },
    {
      id: 4,
      applicantName: "Fatima Noor",
      email: "fatima.noor@email.com",
      phone: "+92 345 7778888",
      location: "Multan, Pakistan",
      appliedDate: "2025-01-10",
      status: "Rejected",
      expertise: "Data Science & ML",
      experience: "3 years",
      education: "MS Data Science",
      currentRole: "Data Scientist at DataCorp",
      linkedIn: "linkedin.com/in/fatimanoor",
      portfolio: "fatimanoor.github.io",
      expectedStudents: 20,
      availability: "Weekdays",
      hourlyRate: "$35",
      documents: [
        { type: "Resume/CV", name: "Fatima_CV.pdf", size: "1.7 MB" },
        {
          type: "Degree Certificate",
          name: "MS_DataScience.pdf",
          size: "1.3 MB",
        },
      ],
      bio: "Data scientist specializing in machine learning and predictive analytics. Working on cutting-edge AI projects.",
      skills: ["Python", "TensorFlow", "Pandas", "SQL", "Machine Learning"],
      certifications: ["IBM Data Science Professional"],
      previousMentoring: "None",
      rating: null,
      rejectionReason:
        "Insufficient mentoring experience. Recommended to gain more practical teaching experience.",
      rejectedDate: "2025-01-11",
      rejectedBy: "Admin John",
    },
    {
      id: 5,
      applicantName: "Bilal Ahmed",
      email: "bilal.ahmed@email.com",
      phone: "+92 312 4445555",
      location: "Faisalabad, Pakistan",
      appliedDate: "2025-01-07",
      status: "Under Review",
      expertise: "Mobile App Development",
      experience: "7 years",
      education: "BS Software Engineering",
      currentRole: "Mobile Lead at AppWorks",
      linkedIn: "linkedin.com/in/bilalahmed",
      portfolio: "bilalahmed.dev",
      expectedStudents: 35,
      availability: "Weekends & Evenings",
      hourlyRate: "$55",
      documents: [
        { type: "Resume/CV", name: "Bilal_Resume.pdf", size: "2.0 MB" },
        { type: "Degree Certificate", name: "BS_SE.pdf", size: "1.6 MB" },
        {
          type: "Experience Letter",
          name: "AppWorks_Letter.pdf",
          size: "820 KB",
        },
        { type: "Portfolio", name: "App_Portfolio.pdf", size: "4.5 MB" },
      ],
      bio: "Mobile development expert with experience in iOS and Android. Built 20+ apps with millions of downloads. Excited to share knowledge with aspiring mobile developers.",
      skills: [
        "React Native",
        "Swift",
        "Kotlin",
        "Flutter",
        "Firebase",
        "REST APIs",
      ],
      certifications: [
        "Google Associate Android Developer",
        "iOS Development Nanodegree",
      ],
      previousMentoring: "Mentored 25+ developers at MobileAcademy",
      rating: null,
      reviewNotes: "Strong background. Verification in progress.",
    },
  ];

  // Stats calculations
  const stats = {
    total: applications.length,
    pending: applications.filter((a) => a.status === "Pending").length,
    underReview: applications.filter((a) => a.status === "Under Review").length,
    approved: applications.filter((a) => a.status === "Approved").length,
    rejected: applications.filter((a) => a.status === "Rejected").length,
  };

  // Filter logic
  const filteredApplications = applications.filter((app) => {
    const matchesFilter =
      selectedFilter === "all" ||
      app.status.toLowerCase().replace(" ", "_") === selectedFilter;
    const matchesSearch =
      app.applicantName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      app.expertise.toLowerCase().includes(searchQuery.toLowerCase()) ||
      app.email.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const handleViewDetails = (application) =>
    setSelectedApplication(application);
  const closeModal = () => setSelectedApplication(null);
  const handleViewDocument = (doc) => setViewDocumentModal(doc);
  const closeDocumentModal = () => setViewDocumentModal(null);

  const handleApprove = (appId) => {
    alert(`Approved application ${appId}`);
    closeModal();
  };

  const handleReject = (appId) => {
    const reason = prompt("Please provide rejection reason:");
    if (reason) {
      alert(`Rejected application ${appId}. Reason: ${reason}`);
      closeModal();
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Pending":
        return <Clock className="status-icon pending" />;
      case "Under Review":
        return <Eye className="status-icon review" />;
      case "Approved":
        return <CheckCircle className="status-icon approved" />;
      case "Rejected":
        return <XCircle className="status-icon rejected" />;
      default:
        return <AlertCircle className="status-icon" />;
    }
  };

  return (
    <AdminLayout>
      <div className="mentor-verification-container">
        {/* Header */}
        <div className="verification-header">
          <div>
            <p className="verification-subtitle">
              Review and approve mentor applications
            </p>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="verification-stats-grid">
          <div className="verification-stat-card total">
            <div className="stat-card-top">
              <div className="stat-icon-wrapper">
                <Users size={22} />
              </div>
            </div>
            <div className="stat-content">
              <p className="stat-value">{stats.total}</p>
              <h3 className="stat-label">Total Applications</h3>
            </div>
          </div>
          <div className="verification-stat-card pending">
            <div className="stat-card-top">
              <div className="stat-icon-wrapper">
                <Clock size={22} />
              </div>
            </div>
            <div className="stat-content">
              <p className="stat-value">{stats.pending}</p>
              <h3 className="stat-label">Pending Review</h3>
            </div>
          </div>
          <div className="verification-stat-card review">
            <div className="stat-card-top">
              <div className="stat-icon-wrapper">
                <Eye size={22} />
              </div>
            </div>
            <div className="stat-content">
              <p className="stat-value">{stats.underReview}</p>
              <h3 className="stat-label">Under Review</h3>
            </div>
          </div>
          <div className="verification-stat-card approved">
            <div className="stat-card-top">
              <div className="stat-icon-wrapper">
                <CheckCircle size={22} />
              </div>
            </div>
            <div className="stat-content">
              <p className="stat-value">{stats.approved}</p>
              <h3 className="stat-label">Approved</h3>
            </div>
          </div>
          <div className="verification-stat-card rejected">
            <div className="stat-card-top">
              <div className="stat-icon-wrapper">
                <XCircle size={22} />
              </div>
            </div>
            <div className="stat-content">
              <p className="stat-value">{stats.rejected}</p>
              <h3 className="stat-label">Rejected</h3>
            </div>
          </div>
        </div>

        {/* Controls */}
        <div className="verification-controls">
          <div className="filter-tabs">
            <button
              className={`filter-tab ${selectedFilter === "all" ? "active" : ""}`}
              onClick={() => setSelectedFilter("all")}
            >
              <Filter size={16} />
              All Applications
            </button>
            <button
              className={`filter-tab ${selectedFilter === "pending" ? "active" : ""}`}
              onClick={() => setSelectedFilter("pending")}
            >
              <Clock size={16} />
              Pending ({stats.pending})
            </button>
            <button
              className={`filter-tab ${selectedFilter === "under_review" ? "active" : ""}`}
              onClick={() => setSelectedFilter("under_review")}
            >
              <Eye size={16} />
              Under Review ({stats.underReview})
            </button>
            <button
              className={`filter-tab ${selectedFilter === "approved" ? "active" : ""}`}
              onClick={() => setSelectedFilter("approved")}
            >
              <CheckCircle size={16} />
              Approved
            </button>
            <button
              className={`filter-tab ${selectedFilter === "rejected" ? "active" : ""}`}
              onClick={() => setSelectedFilter("rejected")}
            >
              <XCircle size={16} />
              Rejected
            </button>
          </div>

          <div className="verification-control-actions">
            <div className="search-box">
              <Search size={20} />
              <input
                type="text"
                placeholder="Search applications..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="verification-view-toggle">
              <button
                className={`verification-view-btn ${viewMode === "grid" ? "active" : ""}`}
                onClick={() => setViewMode("grid")}
                title="Grid View"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="3" width="7" height="7"></rect>
                  <rect x="14" y="3" width="7" height="7"></rect>
                  <rect x="14" y="14" width="7" height="7"></rect>
                  <rect x="3" y="14" width="7" height="7"></rect>
                </svg>
              </button>
              <button
                className={`verification-view-btn ${viewMode === "table" ? "active" : ""}`}
                onClick={() => setViewMode("table")}
                title="Table View"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Grid View */}
        {viewMode === "grid" && (
          <div className="applications-grid">
            {filteredApplications.map((app) => (
              <div key={app.id} className="application-card">
                <div className="application-card-header">
                  <div className="applicant-info">
                    <div className="applicant-avatar">
                      {app.applicantName
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </div>
                    <div>
                      <h3>{app.applicantName}</h3>
                      <p className="applicant-expertise">{app.expertise}</p>
                    </div>
                  </div>
                  <div
                    className={`status-badge ${app.status.toLowerCase().replace(" ", "-")}`}
                  >
                    {getStatusIcon(app.status)}
                    <span>{app.status}</span>
                  </div>
                </div>
                <div className="application-details">
                  <div className="detail-row">
                    <Briefcase size={16} />
                    <span>{app.experience} experience</span>
                  </div>
                  <div className="detail-row">
                    <GraduationCap size={16} />
                    <span>{app.education}</span>
                  </div>
                  <div className="detail-row">
                    <MapPin size={16} />
                    <span>{app.location}</span>
                  </div>
                  <div className="detail-row">
                    <Calendar size={16} />
                    <span>Applied: {app.appliedDate}</span>
                  </div>
                </div>
                <div className="application-stats">
                  <div className="stat-item">
                    <TrendingUp size={16} />
                    <span>{app.expectedStudents} students</span>
                  </div>
                  <div className="stat-item">
                    <Award size={16} />
                    <span>{app.certifications.length} certs</span>
                  </div>
                  <div className="stat-item">
                    <FileText size={16} />
                    <span>{app.documents.length} docs</span>
                  </div>
                </div>
                <button
                  className="view-details-btn"
                  onClick={() => handleViewDetails(app)}
                >
                  <Eye size={18} />
                  View Full Application
                </button>
              </div>
            ))}
            {filteredApplications.length === 0 && (
              <div className="empty-state">
                <AlertCircle size={64} />
                <h3>No applications found</h3>
                <p>Try adjusting your filters or search query</p>
              </div>
            )}
          </div>
        )}

        {/* Table View */}
        {viewMode === "table" && (
          <div className="verification-table-wrapper">
            <table className="verification-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Applicant</th>
                  <th>Expertise</th>
                  <th>Experience</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Applied</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredApplications.map((app) => (
                  <tr key={app.id}>
                    <td className="verification-table-id">{app.id}</td>
                    <td>
                      {/* No avatar — plain text only */}
                      <div className="verification-user-cell">
                        <span className="verification-user-name">
                          {app.applicantName}
                        </span>
                        <span className="verification-user-email">
                          {app.email}
                        </span>
                      </div>
                    </td>
                    <td>{app.expertise}</td>
                    <td>{app.experience}</td>
                    <td>{app.location}</td>
                    <td>
                      <div
                        className={`status-badge ${app.status.toLowerCase().replace(" ", "-")}`}
                      >
                        {getStatusIcon(app.status)}
                        <span>{app.status}</span>
                      </div>
                    </td>
                    <td className="verification-date">{app.appliedDate}</td>
                    <td>
                      <button
                        className="verification-view-action-btn"
                        onClick={() => handleViewDetails(app)}
                        title="View Details"
                      >
                        <Eye size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredApplications.length === 0 && (
              <div className="empty-state" style={{ gridColumn: "unset" }}>
                <AlertCircle size={64} />
                <h3>No applications found</h3>
                <p>Try adjusting your filters or search query</p>
              </div>
            )}
          </div>
        )}

        {/* Application Detail Modal */}
        {selectedApplication && (
          <div className="modal-overlay" onClick={closeModal}>
            <div
              className="modal-content large"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <div className="modal-applicant-header">
                  <div className="modal-avatar">
                    {selectedApplication.applicantName
                      .split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </div>
                  <div>
                    <h3>{selectedApplication.applicantName}</h3>
                    <p>{selectedApplication.expertise}</p>
                  </div>
                </div>
                <button className="close-btn" onClick={closeModal}>
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div
                  className={`status-banner ${selectedApplication.status.toLowerCase().replace(" ", "-")}`}
                >
                  {getStatusIcon(selectedApplication.status)}
                  <div>
                    <strong>
                      Application Status: {selectedApplication.status}
                    </strong>
                    {selectedApplication.verifiedDate && (
                      <p>
                        Verified on {selectedApplication.verifiedDate} by{" "}
                        {selectedApplication.verifiedBy}
                      </p>
                    )}
                    {selectedApplication.rejectedDate && (
                      <p>
                        Rejected on {selectedApplication.rejectedDate} by{" "}
                        {selectedApplication.rejectedBy}
                      </p>
                    )}
                  </div>
                </div>
                {selectedApplication.rejectionReason && (
                  <div className="rejection-notice">
                    <AlertCircle size={20} />
                    <div>
                      <strong>Rejection Reason:</strong>
                      <p>{selectedApplication.rejectionReason}</p>
                    </div>
                  </div>
                )}
                <div className="info-section">
                  <h4>
                    <Mail size={20} />
                    Contact Information
                  </h4>
                  <div className="info-grid">
                    <div className="info-item">
                      <Mail size={16} />
                      <span>{selectedApplication.email}</span>
                    </div>
                    <div className="info-item">
                      <Phone size={16} />
                      <span>{selectedApplication.phone}</span>
                    </div>
                    <div className="info-item">
                      <MapPin size={16} />
                      <span>{selectedApplication.location}</span>
                    </div>
                  </div>
                </div>
                <div className="info-section">
                  <h4>
                    <Briefcase size={20} />
                    Professional Background
                  </h4>
                  <div className="info-grid">
                    <div className="info-item">
                      <Briefcase size={16} />
                      <div>
                        <strong>Current Role</strong>
                        <p>{selectedApplication.currentRole}</p>
                      </div>
                    </div>
                    <div className="info-item">
                      <GraduationCap size={16} />
                      <div>
                        <strong>Education</strong>
                        <p>{selectedApplication.education}</p>
                      </div>
                    </div>
                    <div className="info-item">
                      <TrendingUp size={16} />
                      <div>
                        <strong>Experience</strong>
                        <p>{selectedApplication.experience}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="info-section">
                  <h4>
                    <MessageSquare size={20} />
                    Bio & Introduction
                  </h4>
                  <p className="bio-text">{selectedApplication.bio}</p>
                </div>
                <div className="info-section">
                  <h4>
                    <Award size={20} />
                    Skills & Certifications
                  </h4>
                  <div className="skills-list">
                    {selectedApplication.skills.map((skill, index) => (
                      <span key={index} className="skill-badge">
                        {skill}
                      </span>
                    ))}
                  </div>
                  <div className="certifications-list">
                    {selectedApplication.certifications.map((cert, index) => (
                      <div key={index} className="cert-item">
                        <Award size={16} />
                        <span>{cert}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="info-section">
                  <h4>
                    <ExternalLink size={20} />
                    Links & Portfolio
                  </h4>
                  <div className="links-grid">
                    <a
                      href={`https://${selectedApplication.linkedIn}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-item"
                    >
                      <ExternalLink size={16} />
                      LinkedIn Profile
                    </a>
                    <a
                      href={`https://${selectedApplication.portfolio}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-item"
                    >
                      <ExternalLink size={16} />
                      Portfolio Website
                    </a>
                  </div>
                </div>
                <div className="info-section">
                  <h4>
                    <FileText size={20} />
                    Submitted Documents ({selectedApplication.documents.length})
                  </h4>
                  <div className="documents-grid">
                    {selectedApplication.documents.map((doc, index) => (
                      <div key={index} className="document-card">
                        <FileText size={24} />
                        <div className="doc-info">
                          <strong>{doc.type}</strong>
                          <p>{doc.name}</p>
                          <span className="doc-size">{doc.size}</span>
                        </div>
                        <div className="doc-actions">
                          <button
                            onClick={() => handleViewDocument(doc)}
                            title="View"
                          >
                            <Eye size={16} />
                          </button>
                          <button title="Download">
                            <Download size={16} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="info-section">
                  <h4>
                    <Users size={20} />
                    Mentoring Details
                  </h4>
                  <div className="info-grid">
                    <div className="info-item">
                      <Users size={16} />
                      <div>
                        <strong>Expected Students</strong>
                        <p>{selectedApplication.expectedStudents} students</p>
                      </div>
                    </div>
                    <div className="info-item">
                      <Clock size={16} />
                      <div>
                        <strong>Availability</strong>
                        <p>{selectedApplication.availability}</p>
                      </div>
                    </div>
                    <div className="info-item">
                      <Star size={16} />
                      <div>
                        <strong>Previous Mentoring</strong>
                        <p>{selectedApplication.previousMentoring}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {selectedApplication.status === "Pending" ||
              selectedApplication.status === "Under Review" ? (
                <div className="modal-footer">
                  <button className="modal-btn secondary" onClick={closeModal}>
                    Cancel
                  </button>
                  <button
                    className="modal-btn reject"
                    onClick={() => handleReject(selectedApplication.id)}
                  >
                    <ThumbsDown size={18} />
                    Reject Application
                  </button>
                  <button
                    className="modal-btn approve"
                    onClick={() => handleApprove(selectedApplication.id)}
                  >
                    <ThumbsUp size={18} />
                    Approve Mentor
                  </button>
                </div>
              ) : (
                <div className="modal-footer">
                  <button className="modal-btn secondary" onClick={closeModal}>
                    Close
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Document Viewer Modal */}
        {viewDocumentModal && (
          <div className="modal-overlay" onClick={closeDocumentModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>
                  <FileText size={24} />
                  {viewDocumentModal.type}
                </h3>
                <button className="close-btn" onClick={closeDocumentModal}>
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="document-viewer">
                  <FileText size={64} />
                  <h4>{viewDocumentModal.name}</h4>
                  <p>Size: {viewDocumentModal.size}</p>
                  <p className="doc-preview-note">
                    Document preview will be displayed here
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="modal-btn secondary"
                  onClick={closeDocumentModal}
                >
                  Close
                </button>
                <button className="modal-btn primary">
                  <Download size={18} />
                  Download
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default MentorsVerification;
